/*///////////...START Custom JS....///////////*/
/*///////////......................///////////*/
/*///////////..TOGGLE ACTIVE PILL..///////////*/
$(document).ready(function () {
    $('nav.nav-pills').each(function () {
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
            $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function (e) {
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return false;
        });
    });
});
/*///////////......................///////////*/
/*///////////....NAV-BAR SCROLL....///////////*/
// duration of scroll animation
var scrollDuration = 200;

// paddles
var leftPaddle = document.getElementsByClassName("left-paddle");
var rightPaddle = document.getElementsByClassName("right-paddle");

// get nav-items dimensions
var itemsLength = $(".nav-item").length;
var itemSize = $(".nav-item").outerWidth(true);

// get some relevant size for the paddle triggering point
var paddleMargin = 20;

// get wrapper width
var getMenuWrapperSize = function () {
    return $(".nav-row").outerWidth();
};
var menuWrapperSize = getMenuWrapperSize();

// the wrapper is responsive
$(window).on("resize", function () {
    menuWrapperSize = getMenuWrapperSize();
});

// size of the visible part of the nav-pills is equal as the wrapper size
var menuVisibleSize = menuWrapperSize;

// get total width of all nav-pills nav-items
var getMenuSize = function () {
    return itemsLength * itemSize;
};
var menuSize = getMenuSize();

// get how much of nav-pills is invisible
var menuInvisibleSize = menuSize - menuWrapperSize;

// get how much have we scrolled to the left
var getMenuPosition = function () {
    return $(".nav-pills").scrollLeft();
};

// finally, what happens when we are actually scrolling the nav-pills
$(".nav-pills").on("scroll", function () {
    // get how much of nav-pills is invisible
    menuInvisibleSize = menuSize - menuWrapperSize;

    // get how much have we scrolled so far
    var menuPosition = getMenuPosition();

    var menuEndOffset = menuInvisibleSize - paddleMargin;

    // show & hide the paddles
    // depending on scroll position
    if (menuPosition <= paddleMargin) {
        $(leftPaddle).addClass("hidden");
        $(rightPaddle).removeClass("hidden");
    }
    else if (menuPosition < menuEndOffset) {
        // show both paddles in the middle
        $(leftPaddle).removeClass("hidden");
        $(rightPaddle).removeClass("hidden");
    }
    else if (menuPosition >= menuEndOffset) {
        $(leftPaddle).removeClass("hidden");
        $(rightPaddle).addClass("hidden");
    }

    // print important values
    $("#print-wrapper-size span").text(nav - pillsWrapperSize);
    $("#print-menu-size span").text(menuSize);
    $("#print-menu-invisible-size span").text(menuInvisibleSize);
    $("#print-menu-position span").text(menuPosition);
});

// scroll to left
$(rightPaddle).on("click", function () {
    $(".nav-pills").animate({
        scrollLeft: menuInvisibleSize
    }, scrollDuration);
});

// scroll to right
$(leftPaddle).on("click", function () {
    $(".nav-pills").animate({
        scrollLeft: "0"
    }, scrollDuration);
});
/*///////////.........................///////////*/
/*///////////...HEADER ANNOUNCEMENT...///////////*/
$('.storeOpen').text(openText);
/*///////////.........................///////////*/